(function() {
	'use strict';
	var $ = avm.require('cash'),
		$window = $(window),
		$question = $('.js-question'),
		$arrowLeft = $('.js-arrow-left'),
		$arrowRight = $('.js-arrow-right'),
		$reviews = $('.js-reviews'),
		$review = $('.js-review'),
		reviewsCount = $review.length,

		reviewWidth = function() {
			return $review.outerWidth();
		},
		reviewsWidth = function() {
			return reviewWidth() * reviewsCount;
		},
		currentPosition = function() {
			return parseInt($reviews.css('left').slice(0, -2));
		},
		$slider = $('.js-slider'),
		mediaQuery = function() {
			var screen = window.getComputedStyle ? window.getComputedStyle(document.body, ':after').getPropertyValue('content') : '';
			return screen;
		},
		// function serves different settings for different resolutions
		// Get number of displayed reviews by screen size
		mediaQueryLogic = function() {
			if (mediaQuery() === '\'desktop\'' || mediaQuery() === '"desktop"' || mediaQuery() === 'desktop') {
				return {
					reviewsShown: 3,
					graphWidth: 950
				};
			} else if (mediaQuery() === '\'custom\'' || mediaQuery() === '"custom"' || mediaQuery() === 'custom') {
				return {
					reviewsShown: 2,
					graphWidth: 950
				};
			} else if (mediaQuery() === '\'tablet\'' || mediaQuery() === '"tablet"' || mediaQuery() === 'tablet') {
				return {
					reviewsShown: 2,
					graphWidth: 600
				};
			} else {
				return {
					reviewsShown: 1,
					graphWidth: 300
				};
			}
		},
		slideLeft = function() {
			// prevent multiple clicking
			$arrowRight.off('click');
			setTimeout(function() {
				$arrowRight.on('click', slideLeft);
			}, 600);

			if (reviewsWidth() - reviewWidth() * mediaQueryLogic().reviewsShown > -currentPosition()) {
				$reviews.animate({
					left: '-' + (-currentPosition() + reviewWidth() * mediaQueryLogic().reviewsShown) + 'px'
				}, 500);
			}
		},
		slideRight = function() {
			// prevent multiple clicking
			$arrowLeft.off('click');
			setTimeout(function() {
				$arrowLeft.on('click', slideRight);
			}, 600);

			if (reviewsWidth() > -currentPosition()) {
				$reviews.animate({
					left: '-' + (-currentPosition() - reviewWidth() * mediaQueryLogic().reviewsShown) + 'px'
				}, 500);
			}
		};

	// init functions
	mediaQueryLogic();
	$reviews.css('width', reviewsWidth() + 'px');
	$slider.css('width', reviewWidth() * mediaQueryLogic().reviewsShown + 'px');

	// resize functions
	$window.on('resize', function() {
		mediaQueryLogic();
		$slider.css('width', reviewWidth() * mediaQueryLogic().reviewsShown + 'px');
	});

	// PEOPLE section slider
	$arrowLeft.on('click', slideRight);
	$arrowRight.on('click', slideLeft);

	// FAQ section accordion
	$question.on('click', function() {
		$question.removeClass('active');
		$(this).addClass('active');
	});

})();

if (avastGlobals.detect.os.isWindows) {
	if (avastGlobals.detect.os.version) {
			$('.windowsVersion').text(' ' + avastGlobals.detect.os.version);
	}
}

var sliderMyCarousel = tns({
	container: '.slider-win10-av-reviews',
	controlsContainer: '.slider-win10-av-reviews-controls',
	controlsPosition: 'bottom',
	controls: false,
	navPosition: 'bottom',
	mouseDrag: true,
	speed: 400,
	fixedWidth: 304,
	preventScrollOnTouch: 'auto',
	responsive: {
		576: {
			center: true
		},
		768: {
			items: 2,
			slideBy: 2,
			controls: true,
			center: false
		},
		1280: {
			fixedWidth: 408
		},
		1366: {
			fixedWidth: 436
		},
		1600: {
			fixedWidth: 464
		}
	}
});
